// extracted by mini-css-extract-plugin
module.exports = {"paginadoContainer":"Paginado_paginadoContainer__3lcjk","li":"Paginado_li__3yeSq","buttons":"Paginado_buttons__35zIo"};